 function restyleRF(container) {
    container.querySelectorAll('.bss-b2b-rf-field.field-file.bss-b2b-grid-col-3').forEach(element => {
        let label = element.querySelector('label');
        if (!label) return;
        let title = (label.getAttribute('title') || '').trim();
        if (element.querySelector('.bss-custom')) return;

        if (title.includes('Upload your W9 File')) {
            let a = document.createElement('div');
            a.className = 'bss-custom';
            a.innerHTML = `
                If you don't have a completed W-9 form, <a href="https://cdn.shopify.com/s/files/1/0579/7819/1916/files/fw9.pdf?v=1784535663" target="_blank">Click here to download a blank W-9 form</a>, fill it out, and then upload it below.
            `;
            label.after(a);
        }

        if (title.includes('Upload Your Resale Certificate OR Sales and Use Tax Certificate')) {
            let a = document.createElement('div');
            a.className = 'bss-custom';
            a.innerHTML = `
                Please upload your Resale Certificate. If you do not have a Resale Certificate, <a href="https://cdn.shopify.com/s/files/1/0579/7819/1916/files/Uniform-Sales-and-Use-Certificate.pdf?v=1784535673" target="_blank">Click here to download the Sales and Use Tax Certificate form</a>, sign it, and then upload it instead.
            `;
            label.after(a);
        }
    });
}

function moveTermsTextIntoCheckbox(rfForm) {
    rfForm.querySelectorAll('.bss-b2b-rf-field.field-checkbox').forEach(checkboxField => {
        if (checkboxField.dataset.termsMoved) return;

        const prev = checkboxField.previousElementSibling;
        if (!prev || !prev.classList.contains('field-header')) return;

        const h5 = prev.querySelector('h5');
        if (!h5) return;

        const label = checkboxField.querySelector('label.label-field');
        if (!label) return;

        label.after(h5);

        prev.style.display = 'none';

        checkboxField.dataset.termsMoved = 'true';
    });
}

const rfObserver = new MutationObserver(() => {
    document.querySelectorAll('#bss-b2b-registration-form').forEach(rfForm => {
        restyleRF(rfForm);
        moveTermsTextIntoCheckbox(rfForm);
    });
});

rfObserver.observe(document.body, { childList: true, subtree: true });

document.querySelectorAll('#bss-b2b-registration-form').forEach(rfForm => {
    restyleRF(rfForm);
    moveTermsTextIntoCheckbox(rfForm);
});